export enum AdminType {
  SUPER_ADMIN = "developer_created_admin",
  ADMIN_USER = "admin_created_admin",
}
